// Page with Tabs <-> Dropdown
// Tabs on Bigger screen // Dropdown on Mobile Only
const initDropdown = () => {
  if (menuResponsiveMode !== "mobile") {
    return;
  }
  // Start with collapsed state
  $(".js-tabs-and-dropdown li:not(.js-dropdown-init)").css("display", "none");

  // Replace the text of the first dropdown menu with active tab
  $(".js-tabs-and-dropdown li.js-dropdown-init")
    .children("span")
    .html(
      $(".js-tabs-and-dropdown li.tabs-title.is-active").children("a").html()
    );

  $(".js-tabs-and-dropdown").on("click", ".js-dropdown-init", function (e) {
    if (menuResponsiveMode !== "mobile") {
      return;
    }
    e.stopPropagation();

    $(this).closest("ul").children("li:not(.js-dropdown-init)").slideDown();
    $(this).children("span").toggleClass("toggled");
  });

  var allOptions = $(".js-tabs-and-dropdown").children(
    "li:not(.js-dropdown-init)"
  );

  $(".js-tabs-and-dropdown").on(
    "click",
    "li:not(.js-dropdown-init)",
    function () {
      if (menuResponsiveMode !== "mobile") {
        return;
      }
      allOptions.removeClass("selected");
      allOptions.slideUp();
      $(this).addClass("selected");
      $("ul")
        .children(".js-dropdown-init")
        .children("span")
        .html($(this).children("a").html());
      $(".js-tabs-and-dropdown .js-dropdown-init")
        .children("span")
        .removeClass("toggled");
    }
  );
};

let menuResponsiveMode = "desktop";
$(window).on("load", function () {
  // First Load
  if (window.matchMedia("(max-width: 1049px)").matches) {
    menuResponsiveMode = "mobile";
  } else {
    menuResponsiveMode = "desktop";
  }

  // ** run functions
  initDropdown();

  $(window).on("resize orientationchange", function () {
    if (window.matchMedia("(max-width: 1049px)").matches) {
      menuResponsiveMode = "mobile";
      initDropdown();
    } else {
      menuResponsiveMode = "desktop";
    }
  });
});

